import React from "react";
import {
  Row,
  Col,
  Typography,
  Tag,
  Space,
  Button,
  Card,
  Badge,
  Dropdown,
  Spin,
  message,
  Divider,
  Avatar,
} from "antd";
import { UserOutlined, SettingOutlined, CopyOutlined } from "@ant-design/icons";
import {
  MdWork,
  MdLocationOn,
  MdSchool,
  MdPerson,
  MdCalendarMonth,
  MdBusiness,
  MdHomeWork,
  MdOutlineCalendarMonth,
  MdBusinessCenter,
} from "react-icons/md";

import { useNavigate, useParams } from "react-router-dom";
import useFirmService from "../../../services/useFirmService";
import PageRoutes from "../../../utils/routes";
import ApplicantsAssignees from "./Components/ApplicantsAssignees";
import { formatTurkishDate } from "../../../utils/formatters";
import JobLocation from "../../Personnel/Advert/Components/JobLocation";

const AdvertDetails = () => {
  const params = useParams();
  const advertId = params.advertId;
  const navigate = useNavigate();

  const { useGetFirmAdvertById } = useFirmService();
  const {
    data: advertDetails,
    isError,
    isLoading,
  } = useGetFirmAdvertById(advertId);
  console.log("advert details is", advertDetails);
  const data = advertDetails?.data;
  if (isLoading) {
    return <Spin spinning={true}></Spin>;
  }

  if (isError) {
    message.error("İlan Detayları Yüklenirken Bir Hata Oluştu");
    navigate(PageRoutes.adverts);
  }

  const items = [
    {
      key: "1",
      label: "İlanı Düzenle",
      onClick: () =>
        navigate(PageRoutes.editAdvert, {
          state: {
            advertId: data.id,
          },
        }),
    },
    {
      key: "2",
      label: "Başvuruları Görüntüle",
      onClick: () => {
        const applicantsSection = document.getElementById(
          "applicants-assignees"
        );
        if (applicantsSection) {
          const yOffset = -20;
          const y =
            applicantsSection.getBoundingClientRect().top +
            window.pageYOffset +
            yOffset;
          window.scrollTo({ top: y, behavior: "smooth" });
        }
      },
    },
    {
      key: "3",
      label: "İlanı Kopyala",
      onClick: () =>
        navigate(PageRoutes.copyAdvert, {
          state: { advertId: data.id },
        }),
    },
  ];

  return (
    <>
      <Card style={{ marginBottom: "20px" }}>
        <Row gutter={[16, 16]} style={{ marginBottom: "20px" }} align="middle">
          {/* Left Column: Icon */}
          <Col xs={2} md={2}>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Avatar
                style={{ width: 100, height: 100 }}
                src={data.firmUser.firm.imageUrl}
              />
            </div>
          </Col>

          <Col xs={16} md={16} style={{ marginLeft: 8 }}>
            <Typography.Title level={4}>{data.title}</Typography.Title>
            <Space size="middle">
              <Typography.Text>
                <UserOutlined style={{ marginRight: 5 }} />
                {data.personnelCount} Kişilik İlan - {data.applicantCount}{" "}
                Başvuru - {data.assigneeCount} Onaylanan Başvuru
              </Typography.Text>
            </Space>
            <Badge
              style={{ display: "block" }}
              status={data.isActive ? "success" : "default"}
              text={data.isActive ? "Aktif İlan" : "Pasif İlan"}
            />{" "}
            <MdOutlineCalendarMonth style={{ marginRight: 5 }} />
            İlan Yayın Tarihleri: {formatTurkishDate(data.advertStartDate)} -
            {formatTurkishDate(data.advertEndDate)}
          </Col>

          {/* Right Column: Actions */}
          <Col xs={4} md={4} style={{ textAlign: "right" }}>
            <Space>
              <Dropdown
                menu={{
                  items,
                  selectable: true,
                }}
                trigger={["click"]}>
                <SettingOutlined
                  style={{ fontSize: "20px", cursor: "pointer" }}
                />
              </Dropdown>
            </Space>
          </Col>
        </Row>
        <Row gutter={[16, 16]}>
          <Tag>Sektör: {data.sector.name}</Tag>
          <Tag>Pozisyon: {data.position.name}</Tag>
          <Tag>Departman: {data.department.name}</Tag>
          <Tag>İş Tipi: {data.jobType.description}</Tag>
          <Tag>İş Periyodu: {data.durationType.description}</Tag>
          <Tag>İş Süresi: {data.jobDuration} </Tag>
          {data.startDate !== null && (
            <Tag>İş Tarihleri: {`${data.startDate} - ${data.endDate}`}</Tag>
          )}
          <Tag>
            Maaş:{" "}
            {`${data.wagePeriod.description} ${data.wageType.description}: `}
            {data.wage !== null
              ? data.wage
              : `${data.minWage} - ${data.maxWage} TRY`}
          </Tag>
          {data.minEducationLevel !== null && (
            <Tag>Min. Eğitim: {data.minEducationLevel.description}</Tag>
          )}
          {data.minAge !== null && (
            <Tag>
              Yaş: {data.minAge}-{data.maxAge}
            </Tag>
          )}
          {data.isExperienceRequired !== false ? (
            <Tag>Deneyim: {data.experienceYear} Yıl</Tag>
          ) : (
            <Tag>Deneyim Aranmıyor</Tag>
          )}
        </Row>

        <div style={{ marginTop: "20px" }}>
          <Typography.Title level={5}> İşin Tanımı</Typography.Title>
          <Typography.Paragraph>{data.jobDescription}</Typography.Paragraph>
        </div>
        <div style={{ marginTop: "10px" }}>
          <Typography.Title level={5}>Aranan Nitelikler</Typography.Title>
          <Typography.Paragraph>
            {data.requiredQualification}
          </Typography.Paragraph>
        </div>
        {/* <div style={{ marginTop: "10px" }}>
                      <Typography.Title level={5}>İlan Konumu</Typography.Title>
                      <Typography.Paragraph>
                        Adres: {data.address} {data?.district.name}{" "}
                        {data?.district?.city?.name} {data?.country}
                      </Typography.Paragraph>
                    </div> */}
        <div style={{ marginBottom: "40px" }}>
          <Typography.Title level={5}>Anahtar Kelimeler</Typography.Title>
          {data.keywords.map((item) => {
            return <Tag color="green">{item}</Tag>;
          })}
          {data.keywords.length === 0 && "Anahtar Kelimeler Bulunmuyor"}
        </div>
        <Divider orientation="left"> İlan Özellikleri</Divider>
        {data.options.map((option) => (
          <div key={option.id}>
            <Typography.Title level={5}>{option.name}</Typography.Title>
            {option.options.map((opt) => {
              return (
                <Tag
                  key={opt.id}
                  color={opt.isSelected === true ? "green" : "grey"}>
                  {opt.name}
                </Tag>
              );
            })}
          </div>
        ))}

        {/* Responsibilities, Qualifications, and Skills */}
        <Row gutter={[8, 8]} style={{ marginTop: "20px" }}>
          <div style={{ width: "100%" }}>
            <Typography.Title level={4} style={{ marginBottom: "24px" }}>
              Detaylar
            </Typography.Title>
            <Space direction="vertical" size="large" style={{ width: "100%" }}>
              <Row justify="space-between">
                <Col xs={24} md={12}>
                  <Typography.Text strong>
                    <MdBusiness
                      style={{
                        marginRight: 5,
                        fontSize: 18,
                        verticalAlign: "middle",
                      }}
                    />
                    Sektör:
                  </Typography.Text>{" "}
                  {data.sector.name}
                </Col>
                <Col xs={24} md={12}>
                  <Typography.Text strong>
                    <MdWork
                      style={{
                        marginRight: 5,
                        fontSize: 18,
                        verticalAlign: "middle",
                      }}
                    />
                    Pozisyon:
                  </Typography.Text>{" "}
                  {data.position.name}
                </Col>
              </Row>

              <Row justify="space-between">
                <Col xs={24} md={12}>
                  <Typography.Text strong>
                    <MdBusinessCenter
                      style={{
                        marginRight: 5,
                        fontSize: 18,
                        verticalAlign: "middle",
                      }}
                    />
                    Departman:
                  </Typography.Text>{" "}
                  {data.department.name}
                </Col>
                <Col xs={24} md={12}>
                  <Typography.Text strong>
                    <MdSchool
                      style={{
                        marginRight: 5,
                        fontSize: 18,
                        verticalAlign: "middle",
                      }}
                    />
                    Eğitim Düzeyi:
                  </Typography.Text>{" "}
                  {data.minEducationLevel !== null
                    ? data.minEducationLevel.description
                    : "Tercih Yok"}
                </Col>
              </Row>

              <Row justify="space-between">
                <Col xs={24} md={12}>
                  <Typography.Text strong>
                    <MdPerson
                      style={{
                        marginRight: 5,
                        fontSize: 18,
                        verticalAlign: "middle",
                      }}
                    />
                    Yaş Aralığı:
                  </Typography.Text>{" "}
                  {data.minAge !== null ? data.minAge : "Alt Limiti Yok"} -
                  {data.maxAge !== null ? data.maxAge : "Üst Limiti Yok"}
                </Col>
                <Col xs={24} md={12}>
                  <Typography.Text strong>
                    <MdCalendarMonth
                      style={{
                        marginRight: 5,
                        fontSize: 18,
                        verticalAlign: "middle",
                      }}
                    />
                    İlan Tarihi:
                  </Typography.Text>{" "}
                  {formatTurkishDate(data.advertStartDate)} -{" "}
                  {formatTurkishDate(data.advertEndDate)}
                </Col>
              </Row>
              <Row justify="space-between">
                <Col xs={24} md={12}>
                  <Typography.Text strong>
                    <MdHomeWork
                      style={{
                        marginRight: 5,
                        fontSize: 18,
                        verticalAlign: "middle",
                      }}
                    />
                    Açık Adres:
                  </Typography.Text>{" "}
                  {data.address !== null ? data.address : ""}
                </Col>
                <Col xs={24} md={12}>
                  <Typography.Text strong>
                    <MdLocationOn
                      style={{
                        marginRight: 5,
                        fontSize: 18,
                        verticalAlign: "middle",
                      }}
                    />
                    Yer:
                  </Typography.Text>{" "}
                  {data.country === null
                    ? data.district !== null
                      ? `${data.district.name} ${data.district.city.name}`
                      : data.city.name
                    : data.country.name}
                </Col>
              </Row>
            </Space>
          </div>
        </Row>
      </Card>
      <Card style={{ marginBottom: 20 }}>
        <JobLocation
          lat={data.coordinate.latitude}
          long={data.coordinate.longitude}
          marginTop={0}
        />
      </Card>
      <div id="applicants-assignees">
        <ApplicantsAssignees
          applicants={data.applicants}
          assignees={data.assignees}
        />
      </div>
    </>
  );
};

export default AdvertDetails;
